export enum CopilotScoreFeedbackSubmittedSelection {
  THUMBSUP = 'thumbsup',
  THUMBSDOWN = 'thumbsdown',
}
